import { alpha, darken, lighten } from "@mui/material/styles";
import { orange, purple, red } from "@mui/material/colors";

// ---------------------------------------------------------------------------
// MUI-derived colours shared across the malnutrition components.
//
// The danger/warning surfaces are the exact values MUI's <Alert> computes from
// the default palette — error.light (#ef5350 = red[400]) and warning.light
// (#ff9800 = orange[500]) — so we derive them the same way rather than hard-code
// the resulting hex.
// ---------------------------------------------------------------------------
export const DANGER_BG = lighten(red[400], 0.9); //      Alert error background (#FDEDED)
export const WARNING_BG = lighten(orange[500], 0.9); //  Alert warning background (#FFF4E5)
export const WARNING_TEXT = darken(orange[500], 0.6); // Alert warning text (#663C00)

// purple[500] at 8% opacity — the designer's --purple-tint.
export const PURPLE_TINT = alpha(purple[500], 0.08);
